import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import iView from 'iview'
import { setToken, getToken, canTurnTo, setTitle,clearTenantId,clearLocalCache } from '@/libs/util'
import config from '@/config'
const { homeName } = config

Vue.use(Router)
const router = new Router({
  routes,
  mode: 'hash'
})
const LOGIN_PAGE_NAME = 'login'
const EXTERNAL_LOGIN_PAGE_NAME = 'external-login'

let leafletConfigLoaded = false
let leafletConfigLoadingPromise = null
function hasLeafletTileUrl () {
  const cfg = store.state.app && store.state.app.leafletConfig
  const opt = cfg && cfg.tileLayerOption
  return !!(opt && opt.url)
}
async function ensureLeafletConfigLoaded () {
  if (leafletConfigLoaded) return
  if (hasLeafletTileUrl()) {
    leafletConfigLoaded = true
    return
  }
  if (!leafletConfigLoadingPromise) {
    leafletConfigLoadingPromise = store.dispatch('loadLeafletConfig').catch(() => {})
  }
  await leafletConfigLoadingPromise
  leafletConfigLoadingPromise = null
  if (hasLeafletTileUrl()) leafletConfigLoaded = true
}
//路由权限判断
function checkUser(name){
    //判断页面是否在路由白名单
    var notCheckUser=store.state.app.notCheckMenulist.indexOf(name);
     if(notCheckUser> -1){
       return "next";
     }else{
      //不在白名单，判断是否拥有权限
      //判断验证是否透过
      if(localStorage.getItem("menulist")){
        var allowMneuList=(localStorage.getItem("menulist")).split("|");
        if(localStorage.getItem("menulist")==""||allowMneuList.length==0){
          //退出登录
          setToken("");
          clearLocalCache();
          return "login";
        }else{
          var allowNext=allowMneuList.indexOf(name);
          if(allowNext> -1){
            return "next";
          }else{
            return "not";
          }
        }
      }else{
        //退出登录
        setToken("");
        clearTenantId();
        clearLocalCache();
        return "login";
      }
    }
}
router.beforeEach(async (to, from, next) => {
  iView.LoadingBar.start()
  const token = getToken()
  if (!token && to.name !== LOGIN_PAGE_NAME && to.name !== EXTERNAL_LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: LOGIN_PAGE_NAME
    })
  } else if (!token && (to.name === LOGIN_PAGE_NAME || to.name === EXTERNAL_LOGIN_PAGE_NAME)) {
    // 未登陆且要跳转的页面是登录页或外部登录页
    next()
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页
    next({
      name: homeName
    })
  } else if (token && to.name === EXTERNAL_LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是外部登录页
    next()
  } else {

    //进入其他页面
    //判断是否登录
    //判断是否权限过滤
    if(!token){
      next({
        name: 'login'
      })
    }else{
      //检查权限是否通过
      const checkResult = checkUser(to.name)
      if(checkResult=="login"){
        next({
          name: 'login'
        })
      } else if(checkResult=="next"){
        try {
          await ensureLeafletConfigLoaded()
        } catch (e) {}
        next()
      } else{
        next({ replace: true, name: 'error_401' })
      }
    }
  }
})
router.afterEach(to => {
  setTitle(to, router.app)
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
